import React from 'react';

export const LoginTitle = () => {
	return <h2>Ingresá con tu cuenta</h2>;
};
